<div class="form-field"  [formGroup]="parent" [ngClass]="{'has-error': parent.get(controllerData.controlName).touched
&& parent.get(controllerData.controlName).errors}" role="emailAddress" [attr.aria-describedby]="controllerData['name']">
  <label [id]="controllerData['name']" [attr.for]="pageName+'-'+controllerData['name']" class="form-label">{{controllerData['label']}} </label>
  @if (!loggedInFlag) {
    <p class="Email-help-txt">{{controllerData['content']}}</p>
  }
  <div class="Email-input" [ngClass]="{'register-email': pageName === 'register'}">
    <input [formControlName]="controllerData['controlName']"
      [name]="controllerData['name']" type="text"
      [id]="pageName+'-'+controllerData['name']"
      [(ngModel)]="controllerData.value" aria-invalid="false"
      [placeholder]="controllerData['placeHolder']" maxlength="35"
      minlength="5"
      class="form-control modalClose-focus"
      [value]="controllerData['value']"
      [required]="controllerData['required']"
      (keyup.enter)="validateInput()"
      [disabled]="dobDisabled"
      (blur)="validateInput()"
      />
      @if (parent.get(controlName).touched
        &&
        parent.get(controlName).errors) {
        <div [id]="controlName +'-error'"  class="form-validation-error"
          >
          <i class="icon icon-error" aria-hidden="true"></i>
          @if (parent.get(controlName).touched
            &&
            parent.get(controlName).hasError('required')) {
            <p [id]="controlName +'-error'">{{controllerData['errorMessage']}}</p>
          }
          @if (parent.get(controlName).touched
            &&
            parent.get(controlName).hasError('notValidEmail')) {
            <p [id]="controlName +'-invalid-error'">
              {{controllerData['invalidErrorMessage']}}
            </p>
          }
          @if (parent.get(controlName).touched
            &&
            parent.get(controlName).errors.emailMatch) {
            <p
              [id]="controlName +'-match-error'">
              {{controllerData['misMatchErrorMessage']}}
            </p>
          }
        </div>
      }
    </div>
  </div>